package com.vizio.redwolf.pay.model

import kotlinx.serialization.Serializable

@Serializable
data class OfferIdByLinkingPinClientRequestInfo(
    val linkingPin: String? = null,
    val deviceInstanceId: String? = null
)